import React from "react";
import { cn } from "@/lib/utils";

type CarouselDotButtonProps = {
  index: number;
  selectedIndex: number;
  onClick: () => void;
};

const CarouselDotButton: React.FC<CarouselDotButtonProps> = ({
  index,
  selectedIndex,
  onClick,
}) => {
  return (
    <button
      key={index}
      className={cn("embla__dot", index === selectedIndex && "is-selected")}
      onClick={onClick}
    >
      <span className="sr-only">Slide {index + 1}</span>
    </button>
  );
};

export default CarouselDotButton;
